import { useEffect, RefObject } from "react";
import { Timeline as VisTimeline } from "vis-timeline/esnext";

export const useTimelineSizing = ({
  containerRef,
  timelineRef,
}: {
  containerRef: RefObject<HTMLDivElement>;
  timelineRef: RefObject<VisTimeline>;
}) => {
  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === containerRef.current && timelineRef.current) {
          timelineRef.current.setOptions({
            height: `${entry.contentRect.height - 12}px`,
          });
        }
      }
    });

    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);
};
